/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { EquipmentScheduleDispatchStatuses } from './equipment-schedule-dispatch-statuses';
import { SearchEquipmentRequest } from './search-equipment-request';


export interface SearchEquipmentScheduleJournalRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    from?: string;
    to?: string;
    equipmentIds?: Array<string> | null;
    equipment?: SearchEquipmentRequest;
    scheduleIds?: Array<string> | null;
    statuses?: Array<EquipmentScheduleDispatchStatuses> | null;
    reasonCodes?: Array<string> | null;
}

